import React, {useCallback} from 'react';
import {useTranslation} from 'react-i18next';

import {Button, Checkbox, Divider, Layout, Radio, Text} from '@phonectas/unifon-ui-kit';
import useThreeSixtyNewStore from 'common/stores/threeSixtyStore';
import {shallow} from 'zustand/shallow';
import {VismaResAccState} from '..';
import BillingGroupSelector from './BillingGroupSelector';
import ClientIdSelector from './ClientIdSelctor';

interface MainResContentProps {
    tempResAcc: VismaResAccState;
    onChange: (field: VismaResAccField, value: string | number | boolean | string[] | number[] | null | undefined) => void;
    showSideRes: boolean;
    onShowSideRes: () => void;
    onHideSideRes: () => void;
    downloadReskonto: () => void;
	billingGroups?: string[];
	clientIds?: number[];
}

type VismaResAccField = keyof VismaResAccState;

const MainResContent: React.FC<MainResContentProps> = ({
	tempResAcc,
	onChange,
	onShowSideRes,
	onHideSideRes,
	showSideRes,
	downloadReskonto,
	billingGroups,
	clientIds,
}) => {
	const [t] = useTranslation();
	// const [activeTab, setActiveTab] = useState<string>('1');
	const {isLoading} = useThreeSixtyNewStore(state => ({
		isLoading: state?.isLoading,
	}), shallow);
	// const isCustom = tempResAcc?.includes && tempResAcc?.includes?.length > 0;
	// const tabs = useMemo(() => [
	// 	{value: '1', label: t('Settings').toUpperCase()},
	// 	{value: '2', label: t('Saved').toUpperCase()},
	// ], [t]);

	const handleChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
		onChange(event.target.name as VismaResAccField, event.target.value);
	}, [onChange]);

	// const handleSaveCustomList = useCallback(() => {
	// 	console.log('Save custom list', tempResAcc.includes);
	// }, [tempResAcc]);

	const handleDownloadReskonto = useCallback(() => {
		downloadReskonto();
	}, [downloadReskonto]);

	const canDownload = useCallback(() => {
		if (isLoading) return false;
		if (tempResAcc.account_id === 0) return false;
		if (!tempResAcc.use_entire_account) {
			if (!tempResAcc.item_id || !tempResAcc.client_number) return false;
		}
		if (tempResAcc.includes && tempResAcc.includes.length === 0) return false;
		return true;
	}, [isLoading, tempResAcc]);

	return (
		<Layout
			fullWidth
			nowrap
			direction="column"
			fullHeight
			justifyContent="space-between"
			gap="sm"
		>
			{/* <Layout fullWidth direction="row" nowrap>
				<Tabs
					items={tabs}
					active={activeTab}
					onChange={(value) => setActiveTab(String(value))}
				/>
			</Layout> */}
			<Layout fullWidth direction="row" nowrap>
				<Layout fullWidth nowrap gap="md" >
					<Layout direction="column" nowrap alignItems="start">
						<Text color="textSecondary">{t('Format')}</Text>
						<Layout>
							<Radio
								value={'excel'}
								name='format'
								label={t('xlsx')}
								checked={'excel' === tempResAcc.format}
								onChange={handleChange}
							/>
							<Radio
								value={'csv'}
								name='format'
								label={t('csv')}
								checked={'csv' === tempResAcc.format}
								onChange={handleChange}
							/>
						</Layout>
					</Layout>
					<Divider vertical />
					<Layout direction="column" alignItems="start" nowrap>
						<Text color="textSecondary">{t('Include all available fields')}</Text>
						<Checkbox
							checked={tempResAcc.include_all}
							toggle
							big
							onChange={(e) => onChange('include_all', e.target.checked)}
						/>
					</Layout>
					<Divider vertical />
					<Layout direction="column" alignItems="start">
						<Text color="textSecondary">{t('Export all items for the entire account')}</Text>
						<Checkbox
							checked={tempResAcc.use_entire_account}
							toggle
							big
							onChange={(e) => onChange('use_entire_account', e.target.checked)}
						/>
						{
							!tempResAcc.use_entire_account && billingGroups && (
								<Layout direction="row" alignItems="center" gap="sm">
									<BillingGroupSelector
										billingGroups={billingGroups ?? []}
										onChange={(value) => onChange('item_id', value)}
										required={!tempResAcc.item_id}
									/>
									<ClientIdSelector
										clientIds={clientIds ?? []}
										onChange={(value) => onChange('client_number', value)}
										required={!tempResAcc.client_number}
									/>
								</Layout>
							)
						}
					</Layout>
					<Divider vertical />
					<Layout  direction="column" alignItems="start">
						<Text color="textSecondary">{t('Custom list')}</Text>
						<Checkbox
							checked={showSideRes}
							toggle
							big
							onChange={() => showSideRes ? onHideSideRes() : onShowSideRes()}
						/>
					</Layout>
				</Layout>
			</Layout>
			<Divider />
			<Layout
				justifyContent="end"
				fullWidth
				nowrap
				direction="row"
				gap="xs"
			>
				{/* {
					showSideRes && isCustom && (
						<Button
							variant="secondary"
							onClick={handleSaveCustomList}
						>
							{t('Save list')}
						</Button>
					)
				} */}
				<Button
					color="success"
					variant="primary"
					disabled={!canDownload()}
					onClick={handleDownloadReskonto}
				>
					{t('Download')}
				</Button>
			</Layout>
		</Layout>
	);
};

export default MainResContent;